// web/src/components/EmptyState.tsx — empty view with EXACTLY one CTA (D05: the empty-screen fix).
import { Icon } from './Icon';

export function EmptyState({ icon, title, body, cta }: {
  icon: string; title: string; body?: string; cta?: { label: string; onClick(): void };
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-hair bg-surface/40 px-6 py-12 text-center">
      <span className="flex size-12 items-center justify-center rounded-full bg-surface2 text-muted"><Icon name={icon} size={24} /></span>
      <h3 className="font-head text-lg text-ink">{title}</h3>
      {body && <p className="max-w-sm text-sm text-muted">{body}</p>}
      {cta && (
        <button onClick={cta.onClick}
          className="mt-1 inline-flex min-h-11 items-center gap-2 rounded-md bg-run px-4 font-medium text-runink transition-transform active:scale-[0.98]">
          <Icon name="plus" size={16} />{cta.label}
        </button>
      )}
    </div>
  );
}
